var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 10,
    fill: "#FF6376"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8125 5.375C10.1777 5.375 10.5 5.69727 10.5 6.0625V6.49219C12.0684 6.79297 13.25 8.18945 13.25 9.84375V10.252C13.25 11.2617 13.6152 12.25 14.2812 13.002L14.4316 13.1738C14.625 13.3887 14.668 13.668 14.5605 13.9258C14.4531 14.1621 14.1953 14.3125 13.9375 14.3125H5.6875C5.4082 14.3125 5.15039 14.1621 5.04297 13.9258C4.93555 13.668 4.97852 13.3887 5.17188 13.1738L5.32227 13.002C5.98828 12.25 6.375 11.2617 6.375 10.252V9.84375C6.375 8.18945 7.55664 6.79297 9.125 6.49219V6.0625C9.125 5.69727 9.42578 5.375 9.8125 5.375ZM10.7793 15.9883C10.5215 16.2461 10.1777 16.375 9.8125 16.375C9.44727 16.375 9.08203 16.2461 8.82422 15.9883C8.56641 15.7305 8.4375 15.3652 8.4375 15H9.8125H11.1875C11.1875 15.3652 11.0371 15.7305 10.7793 15.9883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/Notification Icon.44f525d2cf74f71a50f1b52434a83d33.svg";
export { ForwardRef as ReactComponent };